import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  it: {
    translation: {
      // Navigation
      "nav.dashboard": "Dashboard",
      "nav.projects": "Progetti",
      "nav.balanceSheet": "Analisi Bilancio",
      "nav.businessPlan": "Business Plan",
      "nav.projectFinancing": "Project Financing",
      "nav.valuation": "Valutazione",
      "nav.settings": "Impostazioni",
      "nav.logout": "Esci",
      
      // Auth
      "auth.login": "Accedi",
      "auth.register": "Registrati",
      "auth.email": "Email",
      "auth.password": "Password",
      "auth.fullName": "Nome Completo",
      "auth.company": "Azienda",
      "auth.forgotPassword": "Password dimenticata?",
      "auth.noAccount": "Non hai un account?",
      "auth.hasAccount": "Hai già un account?",
      
      // Dashboard
      "dashboard.title": "Dashboard",
      "dashboard.welcome": "Bentornato",
      "dashboard.totalProjects": "Progetti Totali",
      "dashboard.balanceSheets": "Analisi Bilancio",
      "dashboard.businessPlans": "Business Plan",
      "dashboard.valuations": "Valutazioni",
      "dashboard.recentProjects": "Progetti Recenti",
      "dashboard.quickActions": "Azioni Rapide",
      
      // Projects
      "projects.title": "Progetti",
      "projects.new": "Nuovo Progetto",
      "projects.name": "Nome Progetto",
      "projects.company": "Nome Azienda",
      "projects.description": "Descrizione",
      "projects.fiscalYear": "Anno Fiscale",
      "projects.currency": "Valuta",
      "projects.collaborators": "Collaboratori",
      "projects.addCollaborator": "Aggiungi Collaboratore",
      "projects.created": "Creato il",
      "projects.updated": "Aggiornato il",
      
      // Balance Sheet
      "balance.title": "Analisi di Bilancio",
      "balance.year": "Anno",
      "balance.assets": "Attivo",
      "balance.liabilities": "Passivo",
      "balance.equity": "Patrimonio Netto",
      "balance.incomeStatement": "Conto Economico",
      "balance.fixedAssets": "Immobilizzazioni",
      "balance.currentAssets": "Attivo Circolante",
      "balance.intangible": "Immobilizzazioni Immateriali",
      "balance.tangible": "Immobilizzazioni Materiali",
      "balance.financial": "Immobilizzazioni Finanziarie",
      "balance.inventory": "Rimanenze",
      "balance.receivables": "Crediti Commerciali",
      "balance.cash": "Disponibilità Liquide",
      "balance.otherReceivables": "Altri Crediti",
      "balance.shareCapital": "Capitale Sociale",
      "balance.reserves": "Riserve",
      "balance.profitLoss": "Utile/Perdita",
      "balance.ltDebt": "Debiti Fin. M/L Termine",
      "balance.stDebt": "Debiti Fin. Breve Termine",
      "balance.payables": "Debiti Commerciali",
      "balance.otherPayables": "Altri Debiti",
      "balance.tfr": "TFR",
      "balance.revenue": "Ricavi",
      "balance.rawMaterials": "Costi Materie Prime",
      "balance.services": "Costi Servizi",
      "balance.personnel": "Costi Personale",
      "balance.depreciation": "Ammortamenti",
      "balance.otherCosts": "Altri Costi",
      "balance.interestExpense": "Oneri Finanziari",
      "balance.interestIncome": "Proventi Finanziari",
      "balance.taxes": "Imposte",
      
      // Indices
      "indices.title": "Indici Finanziari",
      "indices.profitability": "Redditività",
      "indices.liquidity": "Liquidità",
      "indices.leverage": "Indebitamento",
      "indices.roe": "ROE (Return on Equity)",
      "indices.roa": "ROA (Return on Assets)",
      "indices.roi": "ROI (Return on Investment)",
      "indices.ros": "ROS (Return on Sales)",
      "indices.ebitdaMargin": "Margine EBITDA",
      "indices.currentRatio": "Current Ratio",
      "indices.quickRatio": "Quick Ratio",
      "indices.debtEquity": "Debt/Equity",
      "indices.pfn": "PFN (Posizione Fin. Netta)",
      
      // Business Plan
      "bp.title": "Business Plan",
      "bp.new": "Nuovo Business Plan",
      "bp.name": "Nome Piano",
      "bp.startYear": "Anno Inizio",
      "bp.years": "Durata (anni)",
      "bp.assumptions": "Ipotesi",
      "bp.projections": "Proiezioni",
      "bp.revenueGrowth": "Crescita Ricavi %",
      "bp.cogsPercent": "COGS %",
      "bp.opexPercent": "OPEX %",
      "bp.capex": "CAPEX Anno 1",
      "bp.depreciationYears": "Anni Ammortamento",
      "bp.taxRate": "Aliquota Fiscale %",
      "bp.wcDays": "Giorni Capitale Circolante",
      "bp.initialRevenue": "Ricavi Iniziali",
      
      // Project Financing
      "pf.title": "Project Financing",
      "pf.new": "Nuova Analisi",
      "pf.name": "Nome Progetto",
      "pf.initialInvestment": "Investimento Iniziale",
      "pf.duration": "Durata (anni)",
      "pf.discountRate": "Tasso di Sconto %",
      "pf.cashFlows": "Flussi di Cassa",
      "pf.npv": "VAN (NPV)",
      "pf.irr": "TIR (IRR)",
      "pf.payback": "Payback Period",
      "pf.financing": "Finanziamento",
      "pf.amount": "Importo",
      "pf.interestRate": "Tasso Interesse %",
      "pf.loanDuration": "Durata Prestito (anni)",
      "pf.annualPayment": "Rata Annuale",
      "pf.totalInterest": "Interessi Totali",
      
      // Valuation
      "val.title": "Valutazione Aziendale",
      "val.new": "Nuova Valutazione",
      "val.name": "Nome Valutazione",
      "val.method": "Metodo",
      "val.dcf": "DCF (Discounted Cash Flow)",
      "val.multiples": "Multipli di Mercato",
      "val.both": "Entrambi",
      "val.fcf": "Free Cash Flow",
      "val.terminalGrowth": "Crescita Terminale %",
      "val.wacc": "WACC %",
      "val.ebitda": "EBITDA",
      "val.revenue": "Ricavi",
      "val.netIncome": "Utile Netto",
      "val.evEbitda": "EV/EBITDA",
      "val.pSales": "P/Sales",
      "val.pe": "P/E",
      "val.dcfValue": "Valore DCF",
      "val.averageValue": "Valore Medio",
      
      // Export
      "export.title": "Esporta Report",
      "export.pdf": "Esporta PDF",
      "export.excel": "Esporta Excel",
      "export.word": "Esporta Word",
      
      // Common
      "common.save": "Salva",
      "common.cancel": "Annulla",
      "common.delete": "Elimina",
      "common.edit": "Modifica",
      "common.add": "Aggiungi",
      "common.search": "Cerca",
      "common.filter": "Filtra",
      "common.loading": "Caricamento...",
      "common.noData": "Nessun dato disponibile",
      "common.success": "Operazione completata",
      "common.error": "Si è verificato un errore",
      "common.confirm": "Conferma",
      "common.back": "Indietro",
      "common.next": "Avanti",
      "common.year": "Anno",
      "common.actions": "Azioni",
      "common.view": "Visualizza",
      "common.create": "Crea",
      "common.update": "Aggiorna",
      
      // Landing
      "landing.hero.title": "Analisi Finanziaria Professionale",
      "landing.hero.subtitle": "La piattaforma completa per analisi di bilancio, business plan, project financing e valutazione aziendale",
      "landing.hero.cta": "Inizia Ora",
      "landing.features.title": "Funzionalità",
      "landing.features.balance": "Analisi di Bilancio",
      "landing.features.balanceDesc": "Calcolo automatico di tutti gli indici finanziari, patrimoniali ed economici",
      "landing.features.bp": "Business Plan",
      "landing.features.bpDesc": "Crea proiezioni finanziarie complete con analisi di sensibilità",
      "landing.features.pf": "Project Financing",
      "landing.features.pfDesc": "Valuta investimenti con VAN, TIR e analisi del payback",
      "landing.features.val": "Valutazione Aziendale",
      "landing.features.valDesc": "DCF, multipli di mercato e valutazione comparativa",
      "landing.collaboration.title": "Lavora in Team",
      "landing.collaboration.desc": "Collabora con il tuo team su progetti condivisi",
      "landing.export.title": "Export Professionale",
      "landing.export.desc": "Genera report in PDF, Excel e Word",
    }
  },
  en: {
    translation: {
      // Navigation
      "nav.dashboard": "Dashboard",
      "nav.projects": "Projects",
      "nav.balanceSheet": "Balance Sheet",
      "nav.businessPlan": "Business Plan",
      "nav.projectFinancing": "Project Financing",
      "nav.valuation": "Valuation",
      "nav.settings": "Settings",
      "nav.logout": "Logout",
      
      // Auth
      "auth.login": "Login",
      "auth.register": "Register",
      "auth.email": "Email",
      "auth.password": "Password",
      "auth.fullName": "Full Name",
      "auth.company": "Company",
      "auth.forgotPassword": "Forgot password?",
      "auth.noAccount": "Don't have an account?",
      "auth.hasAccount": "Already have an account?",
      
      // Dashboard
      "dashboard.title": "Dashboard",
      "dashboard.welcome": "Welcome back",
      "dashboard.totalProjects": "Total Projects",
      "dashboard.balanceSheets": "Balance Sheets",
      "dashboard.businessPlans": "Business Plans",
      "dashboard.valuations": "Valuations",
      "dashboard.recentProjects": "Recent Projects",
      "dashboard.quickActions": "Quick Actions",
      
      // Projects
      "projects.title": "Projects",
      "projects.new": "New Project",
      "projects.name": "Project Name",
      "projects.company": "Company Name",
      "projects.description": "Description",
      "projects.fiscalYear": "Fiscal Year",
      "projects.currency": "Currency",
      "projects.collaborators": "Collaborators",
      "projects.addCollaborator": "Add Collaborator",
      "projects.created": "Created on",
      "projects.updated": "Updated on",
      
      // Balance Sheet
      "balance.title": "Balance Sheet Analysis",
      "balance.year": "Year",
      "balance.assets": "Assets",
      "balance.liabilities": "Liabilities",
      "balance.equity": "Equity",
      "balance.incomeStatement": "Income Statement",
      "balance.fixedAssets": "Fixed Assets",
      "balance.currentAssets": "Current Assets",
      "balance.intangible": "Intangible Assets",
      "balance.tangible": "Tangible Assets",
      "balance.financial": "Financial Assets",
      "balance.inventory": "Inventory",
      "balance.receivables": "Trade Receivables",
      "balance.cash": "Cash & Equivalents",
      "balance.otherReceivables": "Other Receivables",
      "balance.shareCapital": "Share Capital",
      "balance.reserves": "Reserves",
      "balance.profitLoss": "Profit/Loss",
      "balance.ltDebt": "Long-term Debt",
      "balance.stDebt": "Short-term Debt",
      "balance.payables": "Trade Payables",
      "balance.otherPayables": "Other Payables",
      "balance.tfr": "Employee Benefits",
      "balance.revenue": "Revenue",
      "balance.rawMaterials": "Raw Materials",
      "balance.services": "Services",
      "balance.personnel": "Personnel",
      "balance.depreciation": "Depreciation",
      "balance.otherCosts": "Other Costs",
      "balance.interestExpense": "Interest Expense",
      "balance.interestIncome": "Interest Income",
      "balance.taxes": "Taxes",
      
      // Indices
      "indices.title": "Financial Indices",
      "indices.profitability": "Profitability",
      "indices.liquidity": "Liquidity",
      "indices.leverage": "Leverage",
      "indices.roe": "ROE (Return on Equity)",
      "indices.roa": "ROA (Return on Assets)",
      "indices.roi": "ROI (Return on Investment)",
      "indices.ros": "ROS (Return on Sales)",
      "indices.ebitdaMargin": "EBITDA Margin",
      "indices.currentRatio": "Current Ratio",
      "indices.quickRatio": "Quick Ratio",
      "indices.debtEquity": "Debt/Equity",
      "indices.pfn": "Net Financial Position",
      
      // Business Plan
      "bp.title": "Business Plan",
      "bp.new": "New Business Plan",
      "bp.name": "Plan Name",
      "bp.startYear": "Start Year",
      "bp.years": "Duration (years)",
      "bp.assumptions": "Assumptions",
      "bp.projections": "Projections",
      "bp.revenueGrowth": "Revenue Growth %",
      "bp.cogsPercent": "COGS %",
      "bp.opexPercent": "OPEX %",
      "bp.capex": "CAPEX Year 1",
      "bp.depreciationYears": "Depreciation Years",
      "bp.taxRate": "Tax Rate %",
      "bp.wcDays": "Working Capital Days",
      "bp.initialRevenue": "Initial Revenue",
      
      // Project Financing
      "pf.title": "Project Financing",
      "pf.new": "New Analysis",
      "pf.name": "Project Name",
      "pf.initialInvestment": "Initial Investment",
      "pf.duration": "Duration (years)",
      "pf.discountRate": "Discount Rate %",
      "pf.cashFlows": "Cash Flows",
      "pf.npv": "NPV",
      "pf.irr": "IRR",
      "pf.payback": "Payback Period",
      "pf.financing": "Financing",
      "pf.amount": "Amount",
      "pf.interestRate": "Interest Rate %",
      "pf.loanDuration": "Loan Duration (years)",
      "pf.annualPayment": "Annual Payment",
      "pf.totalInterest": "Total Interest",
      
      // Valuation
      "val.title": "Company Valuation",
      "val.new": "New Valuation",
      "val.name": "Valuation Name",
      "val.method": "Method",
      "val.dcf": "DCF (Discounted Cash Flow)",
      "val.multiples": "Market Multiples",
      "val.both": "Both",
      "val.fcf": "Free Cash Flow",
      "val.terminalGrowth": "Terminal Growth %",
      "val.wacc": "WACC %",
      "val.ebitda": "EBITDA",
      "val.revenue": "Revenue",
      "val.netIncome": "Net Income",
      "val.evEbitda": "EV/EBITDA",
      "val.pSales": "P/Sales",
      "val.pe": "P/E",
      "val.dcfValue": "DCF Value",
      "val.averageValue": "Average Value",
      
      // Export
      "export.title": "Export Report",
      "export.pdf": "Export PDF",
      "export.excel": "Export Excel",
      "export.word": "Export Word",
      
      // Common
      "common.save": "Save",
      "common.cancel": "Cancel",
      "common.delete": "Delete",
      "common.edit": "Edit",
      "common.add": "Add",
      "common.search": "Search",
      "common.filter": "Filter",
      "common.loading": "Loading...",
      "common.noData": "No data available",
      "common.success": "Operation completed",
      "common.error": "An error occurred",
      "common.confirm": "Confirm",
      "common.back": "Back",
      "common.next": "Next",
      "common.year": "Year",
      "common.actions": "Actions",
      "common.view": "View",
      "common.create": "Create",
      "common.update": "Update",
      
      // Landing
      "landing.hero.title": "Professional Financial Analysis",
      "landing.hero.subtitle": "The complete platform for balance sheet analysis, business planning, project financing and company valuation",
      "landing.hero.cta": "Get Started",
      "landing.features.title": "Features",
      "landing.features.balance": "Balance Sheet Analysis",
      "landing.features.balanceDesc": "Automatic calculation of all financial, equity and economic indices",
      "landing.features.bp": "Business Plan",
      "landing.features.bpDesc": "Create complete financial projections with sensitivity analysis",
      "landing.features.pf": "Project Financing",
      "landing.features.pfDesc": "Evaluate investments with NPV, IRR and payback analysis",
      "landing.features.val": "Company Valuation",
      "landing.features.valDesc": "DCF, market multiples and comparative valuation",
      "landing.collaboration.title": "Work as a Team",
      "landing.collaboration.desc": "Collaborate with your team on shared projects",
      "landing.export.title": "Professional Export",
      "landing.export.desc": "Generate reports in PDF, Excel and Word",
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'it',
    fallbackLng: 'it',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
